export default {
  methods: {
    validEmail(email) {
      // eslint-disable-next-line
      const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },

    validPasswordUpperCase(password) {
      const re = /.*[A-Z].*/;
      return re.test(password);
    },

    validPasswordLowerCase(password) {
      const re = /.*[a-z].*/;
      return re.test(password);
    },

    validPasswordNumber(password) {
      const re = /.*[0-9].*/;
      return re.test(password);
    },

    validPasswordChars(password) {
      const re = /[!\"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~]/;
      return re.test(password);
    },

    validPasswordLength(password) {
      return password.length >= 8;
    },

    validPhone(phone) {
      const re = /^(\+\d{1,2}\s?)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/;
      return re.test(phone);
    },

    validGivenNames(name) {
      const regex = /^(?!.*\s{2})[\p{L}\s]{1,60}(?<!\s)$/u;
      return regex.test(name)
    },

    validLastNames(name) {
      const regex = /^[\p{L}]{1,30}(?:\s[\p{L}]{1,30}){0,2}$/u;
      return regex.test(name)
    },

    getUsernameState(username) {
      if (username.length === 0) return null;
      return this.validEmail(username);
    },

    getPasswordState(password) {
      if (password.length === 0) return null;
      return this.validPasswordLength(password)
          && this.validPasswordUpperCase(password)
          && this.validPasswordLowerCase(password)
          && this.validPasswordNumber(password)
          && this.validPasswordChars(password);
    },

    getPasswordMinState(password) {
      if (password.length === 0) return null;
      return this.validPasswordLength(password);
    },

    getPasswordUpperCaseState(password) {
      if (password.length === 0) return null;
      return this.validPasswordUpperCase(password);
    },

    getPasswordLowerCaseState(password) {
      if (password.length === 0) return null;
      return this.validPasswordLowerCase(password);
    },

    getPasswordNumberState(password) {
      if (password.length === 0) return null;
      return this.validPasswordNumber(password);
    },

    getPasswordCharState(password) {
      if (password.length === 0) return null;
      return this.validPasswordChars(password);
    },

    getConfirmPasswordState(password, confirmPassword) {
      if (confirmPassword.length === 0) return null;
      return confirmPassword === password;
    },

    getPhoneState(phone) {
      if (phone.length === 0) return null;
      return this.validPhone(phone);
    },

    getGivenNamesState(givenNames) {
      if (givenNames.length === 0) return null;
      return this.validGivenNames(givenNames);
    },

    getLastNamesState(lastNames) {
      if (lastNames.length === 0) return null;
      return this.validLastNames(lastNames);
    },
  }
};